export const VEHICLE_TYPE_LABELS: Record<string, { en: string; de: string }> = {
  Sedan: { en: "Sedan", de: "Limousine" },
  StationWagon: { en: "Station Wagon", de: "Kombi" },
  VanMinibus: { en: "Van/Minibus", de: "Van / Minibus" },
  SuvPickup: { en: "SUV/Pickup", de: "SUV / Pickup" },
  CityCar: { en: "City Car", de: "Kleinwagen" },
  ConvertibleRoadster: { en: "Convertible/Roadster", de: "Cabrio / Roadster" },
  SportsCarCoupe: { en: "Sports Car/Coupe", de: "Sportwagen / Coupé" },
  OtherPassengerCar: { en: "Other Passenger Car", de: "Sonstiger Pkw" },
  ChopperCruiser: { en: "Chopper/Cruiser", de: "Chopper / Cruiser" },
  DirtBike: { en: "Dirt Bike", de: "Crossmaschine" },
  EnduroAdventure: { en: "Enduro/Adventure", de: "Enduro / Adventure" },
  SidecarCombination: { en: "Sidecar Combination", de: "Gespann" },
  LightMotorcycle: { en: "Light Motorcycle", de: "Leichtkraftrad" },
  MopedMokick: { en: "Moped/Mokick", de: "Moped / Mokick" },
  Motorcycle: { en: "Motorcycle", de: "Motorrad" },
  NakedBike: { en: "Naked Bike", de: "Naked Bike" },
  PocketBike: { en: "Pocket Bike", de: "Pocket Bike" },
  Quad: { en: "Quad", de: "Quad" },
  RallyeCross: { en: "Rallye/Cross", de: "Rallye / Cross" },
  Racing: { en: "Racing", de: "Rennmaschine" },
  RollerScooter: { en: "Roller/Scooter", de: "Roller / Scooter" },
  Scooter: { en: "Scooter", de: "Scooter" },
  SportSuperSport: { en: "Sport/Supersport", de: "Sport / Supersport" },
  Sporttourer: { en: "Sport Tourer", de: "Sporttourer" },
  Streetfighter: { en: "Streetfighter", de: "Streetfighter" },
  SuperMoto: { en: "Supermoto", de: "Supermoto" },
  Tourer: { en: "Tourer", de: "Tourer" },
  Trike: { en: "Trike", de: "Trike" },
  OtherMotorcycles: { en: "Other Motorcycles", de: "Sonstige Motorräder" },
  TowTruck: { en: "Tow Truck", de: "Abschleppfahrzeug" },
  CarTransporter: { en: "Car Transporter", de: "Autotransporter" },
  ThreeWayTipper: { en: "Three-way Tipper", de: "Dreiseitenkipper" },
  ChassisUpTo7p5Tons: { en: "Chassis up to 7.5 Tons", de: "Fahrgestell bis 7,5 t" },
  PanelVan: { en: "Panel Van", de: "Kastenwagen" },
  PanelVanHighRoof: { en: "Panel Van High Roof", de: "Kastenwagen Hochdach" },
  PanelVanHighRoofLong: { en: "Panel Van High Roof Long", de: "Kastenwagen Hochdach lang" },
  PanelVanLong: { en: "Panel Van Long", de: "Kastenwagen lang" },
  BoxTruckUpTo7p5Tons: { en: "Box Truck up to 7.5 Tons", de: "Koffer bis 7,5 t" },
  MinibusUpTo9Seats: { en: "Minibus up to 9 Seats", de: "Minibus bis 9 Sitze" },
  FlatbedUpTo7p5Tons: { en: "Flatbed up to 7.5 Tons", de: "Pritsche bis 7,5 t" },
  FlatbedTarpaulinUpTo7p5Tons: { en: "Flatbed Tarpaulin up to 7.5 Tons", de: "Pritsche/Plane bis 7,5 t" },
  AnimalTransport: { en: "Animal Transport", de: "Tiertransporter" },
  OtherTransportTruckUpTo7p5Tons: { en: "Other Transport Truck up to 7.5 Tons", de: "Sonstiger Transporter bis 7,5 t" },
  OtherTrailer: { en: "Other Trailer", de: "Sonstiger Anhänger" },
  UNKNOWN: { en: "Unknown", de: "Unbekannt" },
};

export const VEHICLE_KIND_LABELS: Record<string, { en: string; de: string }> = {
  UNKNOWN: { en: "Unknown", de: "Unbekannt" },
  MotorVehicle: { en: "Motor vehicle", de: "Kfz" },
  CommercialVehicle: { en: "Commercial vehicle (Nfz)", de: "Nfz (Nutzfahrzeug)" },
  Motorcycle: { en: "Motorcycle (Krad)", de: "Krad (Kraftrad)" },
  Truck: { en: "Truck", de: "LKW" },
};

export const VEHICLE_PAINT_TYPE_LABELS: Record<string, { en: string; de: string }> = {
  Solid: { en: "Solid", de: "Uni" },
  Pearl: { en: "Pearl", de: "Perleffekt" },
  Metallic: { en: "Metallic", de: "Metallic" },
  Matte: { en: "Matte", de: "Matt" },
  Chameleon: { en: "Chameleon", de: "Chamäleon" },
  UNKNOWN: { en: "Unknown", de: "Unbekannt" },
};

export const VEHICLE_FUEL_TYPE_LABELS: Record<string, { en: string; de: string }> = {
  Gasoline: { en: "Gasoline", de: "Benzin" },
  Diesel: { en: "Diesel", de: "Diesel" },
  Lpg: { en: "LPG", de: "Autogas" },
  NaturalGas: { en: "Natural Gas", de: "Erdgas" },
  Electric: { en: "Electric", de: "Elektro" },
  HybridGasoline: { en: "Hybrid Gasoline", de: "Hybrid Benzin" },
  HybridDiesel: { en: "Hybrid Diesel", de: "Hybrid Diesel" },
  Hydrogen: { en: "Hydrogen", de: "Wasserstoff" },
  Ethanol: { en: "Ethanol", de: "Ethanol" },
  UNKNOWN: { en: "Unknown", de: "Unbekannt" },
};

export const VEHICLE_COLOR_LABELS: Record<string, { en: string; de: string }> = {
  Beige: { en: "Beige", de: "Beige" },
  Blue: { en: "Blue", de: "Blau" },
  Brown: { en: "Brown", de: "Braun" },
  Yellow: { en: "Yellow", de: "Gelb" },
  Gold: { en: "Gold", de: "Gold" },
  Green: { en: "Green", de: "Grün" },
  Gray: { en: "Gray", de: "Grau" },
  Orange: { en: "Orange", de: "Orange" },
  Red: { en: "Red", de: "Rot" },
  Black: { en: "Black", de: "Schwarz" },
  Silver: { en: "Silver", de: "Silber" },
  White: { en: "White", de: "Weiß" },
  Purple: { en: "Purple", de: "Lila" },
  UNKNOWN: { en: "Unknown", de: "Unbekannt" },
};
